'use client';

import { HeaderLogo } from './logo/HeaderLogo.tsx';
import React, { ReactNode, useEffect } from 'react';
import useTralentStore from '@/stores';
import HeaderBalance from '@/components/header/balance/HeaderBalance.tsx';
import HeaderNav from '@/components/header/nav/HeaderNav.tsx';
import { cn } from '@utils/cn.tsx';

const Header = ({ className, children }: { className?: string; children?: ReactNode }) => {
	const { getBalance, user } = useTralentStore();

	useEffect(() => {
		!!user && getBalance(user);
	}, [user]);

	return (
		<>
			<div
				className={cn(
					"relative flex min-h-[66px] items-center justify-between gap-[20px] p-[14px_16px]",
					user && 'lg:sticky lg:top-0 lg:z-50 lg:gap-lg lg:border-b-[1px] lg:border-dark-700 lg:bg-dark-950',
					className
				)}>
				<div className={"flex-none"}>
					<HeaderLogo user={user} />
				</div>

				{!children ? (
					user && (
						<>
							<div className='absolute right-[calc(50%_-125px)] top-0 flex h-full w-[250px] items-center justify-center'>
								<HeaderBalance />
							</div>
							<HeaderNav user={user} />
						</>
					)
				) : (
					<>{children}</>
				)}
			</div>
		</>
	);
};

Header.displayName = 'Header';
export { Header };
